<template>
	<v-layout>
		<v-flex sm12 md6>
			<p class="add-event-step-header mb-1">When is this happening?</p>
			<p class="add-event-step-sub-header">Please set dates at least 2 weeks out to give people time to RSVP.</p>
			<v-date-picker class="mt-2 mb-3 hidden-sm-and-up" v-model="date" :allowed-dates="allowedDates" no-title style="width:86vw;"></v-date-picker>
			<v-date-picker class="mt-2 mb-3 hidden-xs-only" v-model="date" :allowed-dates="allowedDates" color="link" no-title></v-date-picker>
			<div class="hidden-xs-only align-center" style="display: inline-flex; width: 100%">
				<!-- <el-time-picker
					id="startTime"
					v-model="startTime2"
					placeholder="Start time"
					:picker-options="{
						start: '08:00',
						step: '00:30',
						end: '21:00'
					}"
					format='HH:mm A'
				></el-time-picker>
				<el-time-picker
					id="endTime"
					v-model="endTime2"
					placeholder="End time"
					:picker-options="{
						start: '08:00',
						step: '00:30',
						end: '22:00',
						minTime: startTime2
					}"
					format='HH:mm A'
				></el-time-picker> -->
				<v-select
					color="link"
					:error="startTimeError"
					v-bind:items="startTimesFunc"
					v-model="startTime"
					label="Start Time"
					single-line
					menu-props="bottom"
					:rules="[rules.startTime]"
					style="width:200px;"
				></v-select>
				<p class="text-xs-center ml-3 mr-3 pt-1">To</p>
				<v-select
					color="link"
					:error="endTimeError"
					v-bind:items="endTimesFunc"
					v-model="endTime"
					label="End Time"
					single-line
					menu-props="bottom"
					:disabled="startTime === null"
					:rules="[rules.endTime]"
					style="width:200px;"
				></v-select>
			</div>
			<v-flex class="hidden-sm-and-up mb-0" align-center>
				<v-select
					:error="startTimeError"
					v-bind:items="startTimesFunc"
					v-model="startTime"
					label="Start Time"
					single-line
					menu-props="bottom"
					:rules="[rules.startTime]"
					class="mb-0"
				></v-select>
				<v-select
					v-bind:items="endTimesFunc"
					v-model="endTime"
					label="End Time"
					single-line
					menu-props="bottom"
					:disabled="startTime === null"
					:rules="[rules.endTime]"
					class="mb-0 mt-0"
				></v-select>
			</v-flex>
			<v-flex xs12>
				<div class="add-event-step-header">Frequency</div>
				<div class="add-event-step-sub-header">Make it a regular thing! ... or just</div>
				<v-radio-group v-model="frequency" :mandatory="false">
					<div v-for="type in types" :key="type.title">
						<v-radio :label="type.title" :value="type.value" :disabled="type.disabled" class="mt-2 mb-1 add-event-radio-selection disabled-radio"></v-radio>
						<div :class="['add-event-radio-description', {'disabled-radio-description': type.disabled}]">
							{{type.description}}
						</div>
						<div v-if="frequency === 'recurring' && type.value === 'recurring'">
							<v-radio-group v-model="recurringFrequency" class="ml-5">
								<v-radio label="Weekly" value="weekly" class="mt-4 mb-1 add-event-radio-selection-small"></v-radio>
								<v-radio label="Monthly" value="monthly" class="mt-2 mb-1 add-event-radio-selection-small"></v-radio>
							</v-radio-group>
							<!-- Repeat by: Add day of month or day of week? -->
						</div>
					</div>
				</v-radio-group>
			</v-flex>
<!-- 	<div class="add-event-step-header">Event Frequency</div>
			<v-radio-group v-model="frequency" :mandatory="false" class="mb-2">
				<div v-for="type in types">
					<v-radio :label="type.title" :value="type.value" class="mt-2 mb-1 add-event-radio-selection"></v-radio>
					<div class="add-event-radio-description">
						{{type.description}}
					</div>
					<div v-if="frequency === 'recurring' && type.value === 'recurring'">
						<v-radio-group v-model="recurringFrequency" class="ml-5">
							<v-radio label="Weekly" value="weekly" class="mt-2 mb-1 add-event-radio-selection"></v-radio>
							<v-radio label="Monthly" value="monthly" class="mt-2 mb-1 add-event-radio-selection"></v-radio>
						</v-radio-group>
					</div>
				</div>
			</v-radio-group> -->
		</v-flex>
		<v-flex md4 offset-md1 hidden-sm-and-down>
			<v-card class="add-event-tip-box">
				<v-card-text class="p-relative pt-5">
					<div class="info-trapezoid p-absolute">
						<div class="info-content">
							<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
						</div>
					</div>
					<p class="add-event-tip-title">Picking a Date</p>
					<p class="add-event-tip-content">We ask hosts to plan all events at least 2 weeks ahead to give people time to RSVP, and to give us time to help with marketing efforts.</p>
					<p class="add-event-tip-title">Start & End Time</p>
					<p class="add-event-tip-content">WRKPRTY coworking events must be at least 4 hours long, but the duration for other types of events can vary.</p>
					<p class="add-event-tip-title">Repeating or On-going Events</p>
					<p class="add-event-tip-content">We definitely encourage creating a recurring event as it is very helpful for guests that like to plan ahead. For example, hosting a WRKPRTY at the same time and place once a week allows people to make this a regular part of their weekly work schedule - and it makes it easier for them to tell others to join too.</p>
					<p class="add-event-tip-content">If you are interested in creating an event with a Series format, please <a @click="setModalOpen({prop:'contactForm', value: true})">contact us</a> so we can help you!</p>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-dialog scrollable v-model="infoDialog">
			<v-card style="width: 100%">
				<v-card-title class="mb-0 pb-2 pt-3">
					<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
				</v-card-title>
				<v-card-text style="max-height:50vh;">
					<p class="add-event-tip-title">Picking a Date</p>
					<p class="add-event-tip-content">We ask hosts to plan all events at least 2 weeks ahead to give people time to RSVP, and to give us time to help with marketing efforts.</p>
					<p class="add-event-tip-title">Start & End Time</p>
					<p class="add-event-tip-content">WRKPRTY coworking events must be at least 4 hours long, but the duration for other types of events can vary.</p>
					<p class="add-event-tip-title">Repeating or On-going Events</p>
					<p class="add-event-tip-content">We definitely encourage creating a recurring event as it is very helpful for guests that like to plan ahead. For example, hosting a WRKPRTY at the same time and place once a week allows people to make this a regular part of their weekly work schedule - and it makes it easier for them to tell other to join too.</p>
					<p class="add-event-tip-content">If you are interested in creating an event with a Series format, please <a @click="setModalOpen({prop:'contactForm', value: true})">contact us</a> so we can help you!</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer>
					</v-spacer>
					<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- <div class="mb-3 add-event-step-info-link" @click="infoDialog=true"><v-icon class="add-event-step-info-icon">fa-info-circle</v-icon> Tips</div> -->
	</v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
export default {
	data() {
		return {
			startTimeError: false,
			endTimeError: false,
			types: [
				{
					title: 'One-time Event',
					value: 'one-time',
					description: 'Just trying things out? Not ready to start a regular gathering? If so, a one-time event is the way to go.',
					disabled: false
				},
				{
					title: 'Recurring Event (recommended)',
					value: 'recurring',
					description: 'Best for helping guests plan ahead and building momentum. Consistency helps reinforce positive habits!',
					disabled: false
				},
				{
					title: 'Series (coming soon)',
					value: 'series',
					description: 'Idea for multi-date gatherings such as MSTRMND or groups or Trainings where ideas build upon prior dats.',
					disabled: true
				}
				// { title: 'Series', value: 'series', description: 'Host a series of wrkprtys that progress toward a goal.' },
			],
			rules: {
				startTime: value => {
					if (this.endTime !== null && value !== null) {
						if (moment(value).add(this.minimumTime, 'h') > moment(this.endTime)) {
							this.startTimeError = true
							this.endTimeError = true
							if (this.minimumTime === 1) {
								return 'Your event cant be less than 1 hour'
							}
							return 'Wrkprty must be ' + this.minimumTime + ' hours or more'
						}
					}
					this.startTimeError = false
					this.endTimeError = false
					return true
				},
				endTime: value => {
					if (this.startTime !== null && value !== null) {
						if (moment(this.startTime).add(this.minimumTime, 'h') > moment(value)) {
							this.startTimeError = true
							this.endTimeError = true
							if (this.minimumTime === 1) {
								return 'Your event cant be less than 1 hour'
							}
							return 'Wrkprty must be ' + this.minimumTime + ' hours or more'
						}
					}
					this.startTimeError = false
					this.endTimeError = false
					return true
				}
			},
			datePicker: false,
			timePicker: false,
			startTimes: [
				'8:00am',
				'8:30am',
				'9:00am',
				'9:30am',
				'10:00am',
				'10:30am',
				'11:00am',
				'11:30am',
				'12:00pm',
				'12:30pm',
				'1:00pm',
				'1:30pm',
				'2:00pm',
				'2:30pm',
				'3:00pm',
				'3:30pm',
				'4:00pm',
				'4:30pm',
				'5:00pm',
				'5:30pm',
				'6:00pm',
				'6:30pm',
				'7:00pm',
				'7:30pm',
				'8:00pm',
				'8:30pm',
				'9:00pm',
				'9:30pm',
				'10:00pm'
			],
			endTimes: [
				'12:00pm',
				'12:30pm',
				'1:00pm',
				'1:30pm',
				'2:00pm',
				'2:30pm',
				'3:00pm',
				'3:30pm',
				'4:00pm',
				'4:30pm',
				'5:00pm',
				'5:30pm',
				'6:00pm',
				'6:30pm',
				'7:00pm',
				'7:30pm',
				'8:00pm',
				'8:30pm',
				'9:00pm',
				'9:30pm',
				'10:00pm',
				'10:30pm',
				'11:00pm',
				'11:30pm',
				'12:00am',
				'12:30am',
				'1:00am',
				'1:30am',
				'2:00am',
				'2:30am'
			]
		}
	},
	beforeRouteLeave(to, from, next) {
		if (![this.date, this.startTime, this.endTime].includes(null)) {
			if (!(this.startTimeError || this.EndTimeError)) {
				this.setAddEventValidStep(from.path)
				this.removeAddEventInvalidStep(from.path)
			} else {
				this.removeAddEventValidStep(from.path)
				this.setAddEventInvalidStep(from.path)
			}
		} else {
			this.removeAddEventValidStep(from.path)
			this.setAddEventInvalidStep(from.path)
		}
		next()
	},
	watch: {
		startTime () {
			this.endTime = null
		},
		endTime () {
			console.log(this.endTime)
		}
	},
	methods: {
		...mapActions([
			'setAddEventProp',
			'setAddEventValidStep',
			'removeAddEventValidStep',
			'setAddEventInvalidStep',
			'removeAddEventInvalidStep',
			'setModalOpen'
		]),
		convertMoment (obj) {
			return obj.format('h:mma')
		},
		goToExtras() {
			this.$router.push('/host/add/event/extras')
		},
		allowedDates(date) {
			let minDate = moment().add(14, 'days')
			let checkDate = moment(date, 'YYYY-MM-DD')
			minDate.set('hour', 0)
			minDate.set('minute', 0)
			minDate.set('second', 0)
			minDate.set('millisecond', 0)
			if (checkDate >= minDate) {
				return true
			} else {
				return false
			}
		},
		resetFields () {
			this.setAddEventProp({prop: 'addonTimeSlot', value: null})
			this.setAddEventProp({prop: 'addonStartTime', value: null})
			this.setAddEventProp({prop: 'addonEndTime', value: null})
			this.setAddEventProp({prop: 'format', value: null})
			this.setAddEventProp({prop: 'formatIndex', value: null})
			this.removeAddEventValidStep('/host/add/event/format/')
			this.removeAddEventValidStep('/host/add/event/format')
			this.removeAddEventValidStep('/host/add/event/extras/')
			this.removeAddEventValidStep('/host/add/event/extras')
		}
	},
	mounted() {
		if (this.date === null) {
			this.date = moment()
				.add(14, 'days')
				.format('YYYY-MM-DD')
		}
	},
	computed: {
		...mapGetters(['getAddEventProp']),
		minimumTime () {
			if (this.getAddEventProp('wrkprtyType') === 'wrkprty') {
				return 4
			} else {
				return 1
			}
		},
		startTimesFunc () {
			// let test = moment('5:00pm', ['h:mm a', 'H:m'])
			// console.log(test)
			let tempMoment = moment(this.date, 'YYYY-MM-DD')
			tempMoment.hours(6)
			tempMoment.minutes(0)
			tempMoment.seconds(0)
			tempMoment.millisecond(0)

			let timeList = []
			for (var i = 0; i < (18 * 4); i++) {
				timeList.push({text: this.convertMoment(tempMoment), value: tempMoment.format()})
				tempMoment.add(15, 'm')
			}
			return timeList
		},
		endTimesFunc () {
			if (this.startTime !== null) {
				let tempMoment = moment(this.startTime)
				
				let timeList = []
				for (var i = 0; i < (12 * 4); i++) {
					tempMoment.add(15, 'm')
					timeList.push({text: this.convertMoment(tempMoment), value: tempMoment.format()})
				}
				return timeList
			}
		},
		date: {
			get() {
				return this.getAddEventProp('date')
			},
			set(val) {
				this.setAddEventProp({ prop: 'date', value: val })
			}
		},
		startTime: {
			get() {
				return this.getAddEventProp('startTime')
			},
			set(val) {
				this.resetFields()
				this.setAddEventProp({ prop: 'startTime', value: val })
			}
		},
		endTime: {
			get() {
				return this.getAddEventProp('endTime')
			},
			set(val) {
				this.resetFields()
				
				this.setAddEventProp({ prop: 'endTime', value: val })
			}
		},
		frequency: {
			get() {
				return this.getAddEventProp('frequency')
			},
			set(val) {
				this.setAddEventProp({ prop: 'frequency', value: val })
			}
		},
		recurringFrequency: {
			get() {
				return this.getAddEventProp('recurringFrequency')
			},
			set(val) {
				this.setAddEventProp({ prop: 'recurringFrequency', value: val })
			}
		},
		infoDialog: {
			get() {
				return this.getAddEventProp('infoDialog')
			},
			set(val) {
				this.setAddEventProp({ prop: 'infoDialog', value: val })
			}
		}
	}
}
</script>

<style>
</style>
